import { AppUtil } from 'kuaidong-lib'
import {
  Competition,
  CompetitionClassStat,
  CompetitionForm,
  CompetitionGradeStat,
  CompetitionRankingBoard,
  CompetitionScopeConfig,
  CompetitionType,
  CreateCompetitionForm,
  LaunchCompetitionForm,
} from 'kuaidong-model'

export class ACompetition {
  static async findById(id: number): Promise<Competition> {
    return AppUtil.httpGET('/school_competition/item/detail', { competition_id: id })
  }

  static async fetchCompetitions(): Promise<Competition[]> {
    return AppUtil.httpGET('/cel/school_competition/list')
  }

  static async fetchTypes(): Promise<CompetitionType[]> {
    return AppUtil.httpGET('/school_competition/types')
  }

  static async fetchCompetitionScopeConfig(): Promise<CompetitionScopeConfig> {
    return AppUtil.httpGET('/school_competition/scope/select')
  }

  static async saveCompetition({ competition, competition_scope }: CompetitionForm): Promise<void> {
    const params = {
      competition_type_id: competition.competition_type.competition_type_id,
      theme_title: competition.theme_title,
      start_time: competition.start_time,
      end_time: competition.end_time,
      description: competition.description,
      take_part_limits: competition.take_part_limits,
      scope_type: competition_scope!.type === 'own_grades' ? 'custom' : competition_scope!.type,
      scope_school_ids: competition_scope!.schools.map((s) => s.school_id),
      scope_grade_ids: competition_scope!.grades.map((g) => g.grade_id),
      scope_class_ids: competition_scope!.clazzes.map((c) => c.id),
    }

    if (!competition.competition_id) {
      return AppUtil.httpPOST('/school_competition/publish', params)
    } else {
      return AppUtil.httpPUT('/school_competition/publish', {
        ...params,
        competition_id: competition.competition_id,
      })
    }
  }
  static adjustOwnGradesScopeType(form: CreateCompetitionForm) {
    if (form.scope_type === 'own_grades') {
      form.scope_type = 'custom'
    }
    return
  }
  static async createCompetition(form: CreateCompetitionForm): Promise<void> {
    this.adjustOwnGradesScopeType(form)
    return await AppUtil.httpPOST('/school_competition/publish', form)
  }

  static async launchCompetition(
    form: LaunchCompetitionForm
  ): Promise<{
    match_id: string
  }> {
    const params: any = {
      match_type: form.match_type,
      introduce: form.introduce,
      match_img_url: '',
      theme_title: form.theme_title,
      start_time: form.start_time,
      end_time: form.end_time,
    }

    const config = {
      limit_score: form.config.config[0].limit_score,
      target_score: form.config.config[0].target_score,
      name: form.config.name,
      game_type: form.config.game_type,
      introduce: form.config.introduce,
      description: '',
      gender: 'A',
      scope_type: form.scope_type,
      scope_list:
        form.scope_type === 'all_school'
          ? null
          : form.scope_type === 'own_grades'
          ? form.scope_grade_ids
          : form.scope_class_ids,
      config: form.config.config.map((c) => ({ id: c.id, title: c.title })),
    }

    params.config = [config]

    return await AppUtil.httpPOST('/school_online_match/create_match', params)
  }

  static async updateCompetition(form: CreateCompetitionForm): Promise<void> {
    this.adjustOwnGradesScopeType(form)
    return await AppUtil.httpPUT('/school_competition/publish', form)
  }

  static async closeCompetition({ competition }: CompetitionForm): Promise<void> {
    const params = {
      competition_id: competition.competition_id,
    }

    return AppUtil.httpDelete('/school_competition/publish', params)
  }

  static async saveDraft({ competition, competition_scope }: CompetitionForm): Promise<void> {
    const params = {
      competition_type_id: competition.competition_type.competition_type_id,
      theme_title: competition.theme_title,
      start_time: competition.start_time,
      end_time: competition.end_time,
      description: competition.description,
      take_part_limits: competition.take_part_limits,
    }

    if (competition_scope) {
      Object.assign(params, {
        scope_type: competition_scope.type === 'own_grades' ? 'custom' : competition_scope!.type,
        scope_school_ids: competition_scope.schools.map((s) => s.school_id),
        scope_grade_ids: competition_scope.grades.map((g) => g.grade_id),
        scope_class_ids: competition_scope.clazzes.map((c) => c.id),
      })
    }

    if (!competition.competition_id) {
      return AppUtil.httpPOST('/school_competition/draft/publish', params)
    } else {
      return AppUtil.httpPUT('/school_competition/draft/publish', {
        ...params,
        competition_id: competition.competition_id,
      })
    }
  }

  static async deleteDraft({ competition }: CompetitionForm): Promise<void> {
    const params = {
      competition_id: competition.competition_id,
    }

    return AppUtil.httpDelete('/school_competition/draft/publish', params)
  }

  static async fetchCompetitionRankings(
    competitionId: number,
    query: { grade_id?: number; class_id?: number } = {}
  ): Promise<CompetitionRankingBoard> {
    return AppUtil.httpGET('/cel/school_competition/students/list', {
      competition_id: competitionId,
      ...query,
    })
  }

  static async exportCompetitionRankings(
    competitionId: number,
    query: { grade_id?: number; class_id?: number } = {}
  ): Promise<string> {
    return AppUtil.httpGET('/cel/school_competition/rank/excel', {
      competition_id: competitionId,
      ...query,
    })
  }

  static async fetchCompetitionGradeStat(competitionId: number): Promise<CompetitionGradeStat> {
    return AppUtil.httpGET('/school_competition/grades/detail', { competition_id: competitionId })
  }

  static async fetchCompetitionClassStat(competitionId: number, gradeId: number): Promise<CompetitionClassStat> {
    return AppUtil.httpGET('/school_competition/classes/detail', { competition_id: competitionId, grade_id: gradeId })
  }
}
